import { z } from "zod";

export const RoomSchema = z.object({
    id: z.string(),
    property_id: z.string(),
    room_type_id: z.string(),
    room_number: z.string(),
    status: z.string(),
    condition: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});

export const DataSchema = z.object({
    id: z.string(),
    property_id: z.string(),
    // Nullable: property deactivation nulls this server-side (DeactivatePropertyChannexJob).
    channex_id: z.string().nullable(),
    name: z.string(),
    description: z.nullable(z.string()).optional(),
    no_of_beds: z.number(),
    cut_of_days: z.number(),
    is_free_allotment: z.boolean(),
    is_auto_assign: z.boolean(),
    is_dynamic_pricing: z.boolean(),
    total_rooms: z.number(),
    created_at: z.string(),
    updated_at: z.string(),
    occ_adults: z.number(),
    occ_children: z.number(),
    occ_infants: z.number(),
    default_occupancy: z.number(),
    room_kind: z.string(),
    capacity: z.number(),
    rooms: z.array(RoomSchema).optional(),
});

const ShowRoomSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: DataSchema,
});

export { ShowRoomSchema };
export type ShowRoomResponse = z.infer<typeof ShowRoomSchema>;